import { render, staticRenderFns } from "./RegistrationStepTwoIndividual.vue?vue&type=template&id=2c107b9c&scoped=true&"
import script from "./RegistrationStepTwoIndividual.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepTwoIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c107b9c",
  null
  
)

export default component.exports